import React from 'react';
import classes from './styles.module.scss';

const DraftBadge = () => (
  <span className={classes.draftBadge}>DRAFT</span>
);

export default DraftBadge;
